export default {"src":"/_next/static/media/e-namad.895ad0a1.svg","height":71,"width":58,"blurWidth":0,"blurHeight":0};